import { QConfigRandomType } from '@exam-management/graphql';

export const RANDOM_CONFIG_LABEL = {
  [QConfigRandomType.AllRandom]: 'สุ่มทั้งชุด',
  [QConfigRandomType.Fixed]: 'เรียงตามลำดับ',
  [QConfigRandomType.RandomByPart]: 'สุ่มแยกตามหมวด',
  [QConfigRandomType.RandomByHierarchy]: 'สุ่มตามลำดับชั้น',
};
